import productApi from '../api/product';
import { showInfoMessage, showErrorMessage } from '../dialogs';

export default {
    methods: {
        goToProductPage(productId) {
            sessionStorage.productId = productId;
            productApi.isGroup(productId).then((response) => {
                if (response.data.data.isGroup == '1') {
                    this.$router.push('/productgrouppage/' + productId);
                } else {
                    this.$router.push('/productpage/' + productId);
                }
            });
        },
        setProductstatusDone(productId, boxnr, colli) {
            productApi
                .done(productId, boxnr, colli)
                .then(() => {
                    this.$router.push('/menu');
                    showInfoMessage(
                        'Status van ' + productId + ' aangepast naar afgewerkt.'
                    );
                })
                .catch(() => {
                    showErrorMessage('Status kon niet gewijzigd worden.');
                });
        },
        navigateToOptimizedPaintlistView(paintlistId) {
            this.$router.push('/optimizedpaintlistview/' + paintlistId);
        },
    },
};
